@if (!isLoading ) {
<virtual-scroller (scroll)="trailerListScroll($event)" #scroll class="trailer-items" [items]="trailers"
    [checkResizeInterval]="175" [modifyOverflowStyleOfParentScroll]="false">
    @for (trailer of scroll.viewPortItems; track trailer; let i = $index) {
<trailer
        [class.selected]="trailer?.trailerNumber === selectedTrailer?.trailerNumber" [trailer]="trailer"
        [class.first]="i === 0"(click)="setSelection(trailer)" [isSelected]="trailer?.trailerNumber === selectedTrailer?.trailerNumber">
    </trailer>
}
</virtual-scroller>
} @else {

    <div class="loading">
        {{localize(langSection.Term, langText.Loading)}}
    </div>

}
